import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAllYesNoList = createAsyncThunk(
  "YesNo/GetAllYesNoList",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/YesNo/GetAllYesNoList", {
        aI_ApplicationInformationId: aI_ApplicationInformationId,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetAllYesNoList");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateYesNoList = createAsyncThunk(
  "YesNo/UpdateYesNoList",
  async (yesNoEvaluationUpdateList, { rejectWithValue }) => {
    try {
        //console.log(yesNoEvaluationUpdateList,"yesNoEvaluationUpdateList");
        
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/YesNo/UpdateYesNoList", {
        yesNoEvaluationUpdateList: yesNoEvaluationUpdateList,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllYesNoListByTaskGuid = createAsyncThunk(
  "YesNo/GetAllYesNoListByTaskGuid",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/YesNo/GetAllYesNoListByTaskGuid",
        {
          subTaskFlowGUID: subTaskFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const YesNoManager = createSlice({
  name: "YesNoManager",
  initialState: {
    YesNoManager: [],
    loadingYesNoManager: false,
    errorYesNoManager: null,
    //------------------update-------------------
    YesNoManagerUpdate: [],
    loadingYesNoManagerUpdate: false,
    errorYesNoManagerUpdate: null,
    //------------------getBySubTask-------------------
    YesNoManagerBySubTask: [],
    loadingYesNoManagerBySubTask: false,
    errorYesNoManagerBySubTask: null,
  },
  reducers: {
    SetYesNoManager: (state, action) => {
      state.YesNoManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllYesNoList.pending, (state, action) => {
        state.loadingYesNoManager = true;
        state.YesNoManager = action.payload;
        state.errorYesNoManager = null;
      })
      .addCase(GetAllYesNoList.fulfilled, (state, action) => {
        state.loadingYesNoManager = false;
        state.YesNoManager = action.payload;
      })
      .addCase(GetAllYesNoList.rejected, (state, action) => {
        state.loadingYesNoManager = false;
        state.errorYesNoManager = action.payload;
      })
      //---------------------update------------------------
      .addCase(UpdateYesNoList.pending, (state, action) => {
        state.loadingYesNoManagerUpdate = true;
        state.YesNoManagerUpdate = action.payload;
        state.errorYesNoManagerUpdate = null;
      })
      .addCase(UpdateYesNoList.fulfilled, (state, action) => {
        state.loadingYesNoManagerUpdate = false;
        state.YesNoManagerUpdate = action.payload;
      })
      .addCase(UpdateYesNoList.rejected, (state, action) => {
        state.loadingYesNoManagerUpdate = false;
        state.errorYesNoManagerUpdate = action.payload;
      })

      .addCase(GetAllYesNoListByTaskGuid.pending, (state, action) => {
        state.loadingYesNoManagerBySubTask = true;
        state.YesNoManagerBySubTask = action.payload;
        state.errorYesNoManagerBySubTask = null;
      })
      .addCase(GetAllYesNoListByTaskGuid.fulfilled, (state, action) => {
        state.loadingYesNoManagerBySubTask = false;
        state.YesNoManagerBySubTask = action.payload;
      })
      .addCase(GetAllYesNoListByTaskGuid.rejected, (state, action) => {
        state.loadingYesNoManagerBySubTask = false;
        state.errorYesNoManagerBySubTask = action.payload;
      });
  },
});

export const { SetYesNoManager } = YesNoManager.actions;

export default YesNoManager.reducer;
